import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-[#F2F7F8]" data-id="element-354" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-355" data-mp="cn7t2z2b2k1g">
        <div className="text-center mb-16" data-id="element-356" data-mp="cm4yoh5rxzgs">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-[#0F4C5C]" data-id="element-357" data-mp="7qhe6f28luhm">
            THE COMPLETE <span className="text-[#0B7A7A]" data-id="element-358" data-mp="3g6116wcbego8">6-IN-1</span> DENTAL INSTRUCTOR{' '}
            <span className="bg-[#0B7A7A] text-white px-2 box-decoration-clone" data-id="element-359" data-mp="3c4fiuvh0ha6n">ATLAS</span> SYSTEM
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-360" data-mp="3pwly8fccbd51">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-[#0B7A7A] shadow-lg shadow-[#0F4C5C]/10' : 'border-slate-200 shadow-sm shadow-[#0F4C5C]/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-361" data-mp="3l2rhnks17ea6" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-[#0B7A7A] text-white font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-362" data-mp="1qgmldkoxrvsi">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-363" data-mp="20e111i31cgjr">
                <span className="w-12 h-12 rounded-xl bg-[#0F4C5C] text-white font-extrabold text-2xl flex items-center justify-center shrink-0 border-b-4 border-[#A7B7C1]" aria-hidden="true" data-id="element-364" data-mp="24gxbglif96cm">
                  0{index + 1}
                </span>
                <div data-id="element-365" data-mp="1gqb3g6lttzup">
                  <div className="text-[#0A6464] font-bold text-sm uppercase tracking-wider" data-id="element-366" data-mp="1gprisi4skxcz">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-[#0F4C5C]" data-id="element-367" data-mp="1prip9p75p87w">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-[#0A6464] font-semibold mb-6 border-l-4 border-[#0B7A7A] pl-4" data-id="element-368" data-mp="x2to5q63p2w5">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-369" data-mp="16tojdk1brctq">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm leading-relaxed" data-id="element-370" data-mp="1214v9t50gzao">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-371" data-mp="9cpti8aw4dha">
                      {volume.questions.map(question => <li key={question} className="text-[#0F4C5C] font-semibold text-sm bg-[#F2F7F8] border border-slate-200 rounded-lg px-3 py-2" data-id="element-372" data-mp="2kyromg55gtah">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-[#0F4C5C] font-bold text-base bg-[#E3EFF1] border-l-4 border-[#0B7A7A] rounded-lg px-4 py-3" data-id="element-373" data-mp="38q6vmm7vfys2">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-slate-700 text-sm leading-relaxed" data-id="element-374" data-mp="2znxmo0s94dgs">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-375" data-mp="1oav6v7xz7rxo">
                <div data-id="element-376" data-mp="1obd86izhwwcg">
                  <p className="text-[#0F4C5C] font-semibold text-sm mb-3" data-id="element-377" data-mp="1obn2ujvhjroh">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-378" data-mp="23l9xy39s248w">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-379" data-mp="2miuodes6xavm">
                        <CheckCircle2 size={18} className="text-[#0B7A7A] shrink-0 mt-0.5" data-id="element-380" data-mp="2mi1ngufwxfle" />
                        <span className="text-slate-700 text-sm" data-id="element-381" data-mp="2ii102kau5u27">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-382" data-mp="28lftvvn2ycws">
                    <p className="text-[#0F4C5C] font-semibold text-sm mb-3" data-id="element-383" data-mp="122pxjcua72pf">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-384" data-mp="x2lizscxoi1u">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-385" data-mp="ry9nx17eahu2">
                          <CheckCircle2 size={18} className="text-[#0B7A7A] shrink-0 mt-0.5" data-id="element-386" data-mp="wyffyihku6co" />
                          <span className="text-slate-700 text-sm" data-id="element-387" data-mp="11om3sg49lmtv">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-388" data-mp="1anzhxm3c2zkx">
                  {volume.sequenceIntro && <p className="text-[#0F4C5C] font-semibold text-sm mb-2" data-id="element-389" data-mp="1fpyiypblpkep">{volume.sequenceIntro}</p>}
                  <p className="text-[#0F4C5C] font-bold text-sm bg-[#E3EFF1] border border-slate-200 rounded-lg px-3 py-2" data-id="element-390" data-mp="1kmyngvssyf3p">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-[#F2F7F8] border border-[#CFE0E4] border-l-4 border-l-[#0F4C5C] rounded-xl p-4 mt-auto" data-id="element-391" data-mp="3eef9vxujzuf5">
                <span className="text-[#0F4C5C] font-bold block mb-1" data-id="element-392" data-mp="39fu5dm89qokw">RESULT</span>
                {volume.resultLead && <p className="text-slate-700 text-sm" data-id="element-393" data-mp="3odcuwqsrt5te">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-[#0F4C5C]" data-id="element-394" data-mp="3jcp7ef3r373x">{volume.resultQuote}</span>
                  </p>}
                <p className="text-slate-700 text-sm" data-id="element-395" data-mp="15sq6zkejio4">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-[#0B7A7A]" data-id="element-396" data-mp="axovaukwo91u">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}